enum Galleries {
    EarlyChildhood = 1,
    DiscoveryHall = 2,
    History = 3,
    Community = 4,
    VehicleCity = 5,
    TravelingExhibit = 6,
    NewAquisitions = 7,
    PastExhibits = 8
}

export class GalleriesEnum_class {
    public static enum = Galleries;

    public static readonly enumByText: {[key: string]: number} = {
        'Early Childhood': 1,
        'Discovery Hall': 2,
        'History': 3,
        'Community': 4,
        'Vehicle City': 5,
        'Traveling Exhibit': 6,
        'New Aquisitions': 7,
        'Past Exhibits': 8
    }

    public static readonly enumByNumber: {[key: number]: string} = {
        1: 'Early Childhood',
        2: 'Discovery Hall',
        3: 'History',
        4: 'Community',
        5: 'Vehicle City',
        6: 'Traveling Exhibit',
        7: 'New Aquisitions',
        8: 'Past Exhibits'
    }
}